import { request } from "@/configs/request";

export class BaseApi {
  protected request = request;
}
